<template>
	<div class="offList">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>订单列表</span>
			<div></div>
		</div>
		<!-- 订单列表 -->
		<div class="listNone" v-if="list.length == 0">暂无订单</div>
		<router-link :to="{name:'offDetail',query: {id:v.order_number}}" :key="x" v-for="(v,x) in list" v-else>
			<div class="list">
				<img :src="v.image[0] | handleUrl" alt="">
				<div class="list-main">
					<div>
						<div>订单编号:</div>
						<div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{v.order_number}}</div>
					</div>
					<div v-if="v.gateway == 1" class="Public">对公订单</div>
					<div class="list-bottom">
						<div>供货方式: {{v.supplies_mode || handleType}}</div>
						<div>{{v.create_time}}</div>
					</div>
				</div>
				<div v-if="v.is_channel == 1 ">
					<div class="list-confirm" v-if="v.state == 0">付款确认中</div>
					<div class="list-confirm" v-if="v.state == 1">付款完成</div>
				</div>
				<div v-else="v.is_channel == 2 ">
					<div class="list-confirm" v-if="v.state == 0">待支付</div>
					<div class="list-confirm" v-if="v.state == 1">付款成功</div>
				</div>
			</div>
		</router-link>
		<div style="width: 100%; height: 3rem;"></div>
		<!-- 提交订单 -->
		<div class="zhezhao" style="background-color: #fff;">
			<router-link to="offline">
				<button>提交新订单</button>
			</router-link>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: []
			}
		},
		created() {
			this.$axios.post(baseUrl + '/mobile/OfflineOrder/offlineOrder', {
				token: localStorage.getItem('Authorization')
			}).then((res) => {
				if (res.data.code == 2) {
					this.list = res.data.data;
					console.log(res.data.data)
				}
			}).catch(function(err) {
				console.log(err);
			});
		},
		filters: {
			'handleType': function(val) {
				switch (val) {
					case 1:
						return val = '俱百家直供';
						break;
					case 2:
						return val = '体验店供货';
						break;
					case 3:
						return val = '其他供货';
						break;
				}
			}
		}
	}
</script>
<style scoped>
	.offList {
		background: #f2f2f2;
		padding-top: 2rem;
	}

	.offList .list {
		display: flex;
		background: #fff;
		width: 96%;
		border-radius: 0.3rem;
		margin: 1rem auto;
		padding: 0.7rem 0.5rem;
		box-sizing: border-box;
		box-sizing: border-box;
		font-size: 0.85rem;
		position: relative;
	}

	.offList .list img {
		width: 6rem;
		height: 6rem;
		border-radius: 0.3rem;
	}

	.offList .list .list-main {
		text-align: left;
		margin-left: 1rem;
		width: 70%;
		color: #333;
	}

	.offList .list .list-main>div:nth-child(1) {
		padding-bottom: 0.5rem;
	}

	.offList .list .list-bottom {
		border-top: 1px solid #ededed;
		padding-top: 0.5rem;
	}

	.offList .list .list-bottom div:nth-child(2) {
		font-size: 0.8rem;
		text-align: right;
		color: #999;
		margin-top: 0.5rem;
		transform: scale(0.9);
	}

	.offList .list .list-confirm {
		position: absolute;
		top: 0.3rem;
		right: 0.5rem;
		color: #f1452f;
	}

	.offList button {
		background: #f1452f;
		outline: none;
		border: none;
		color: #fff;
		border-radius: 1rem;
		font-size: 0.9rem;
		padding: 0.3rem 0.7rem;
		width: 60%;
		position: fixed;
		bottom: 0.5rem;
		right: 0;
		left: 0;
		margin: auto;
	}

	.offList .listNone {
		color: #8b8b8b;
		font-size: 0.8rem;
		margin-top: 3rem;
	}

	.Public {
		color: #fff;
		background-color: #f1452f;
		position: absolute;
		bottom: 0.75rem;
		left: 7.5rem;
		font-size: 0.75rem;
		padding: 0.125rem 0.5625rem;
		border-radius: 0.3125rem;
	}

	.offList .zhezhao {
		background-color: rgb(255, 255, 255);
		width: 100%;
		height: 3.0625rem;
		position: fixed;
		bottom: 0;
		left: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/OfflineList/offList.vue